import ProductItems from "../components/ProductItems";


const ProductPage = () => {
    return (
        <>
            <ProductItems/>
        </>
    )
}

export default ProductPage;